import { gql } from "@apollo/client";

export const FIND_STRATEGY_PRODUCTION_EQUIPMENT_BY_STRATEGY = gql`
  query FindStrategyProductionEquipmentByStrategy($uuid: ID!) {
    findStrategyProductionEquipmentByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }
`;

export const UPDATE_STRATEGY_PRODUCTION_EQUIPMENT = gql`
  mutation UpdateStrategyProductionEquipment(
    $data: UpdateStrategyProductionEquipmentInput!
  ) {
    updateStrategyProductionEquipment(data: $data) {
      summary
      uuid
    }
  }
`;

export const FIND_ALL_PRODUCTION_EQUIPMENTS_BY_STRATEGY_PE = gql`
  query FindAllProductionEquipmentsByStrategyPE($uuid: ID!) {
    findAllProductionEquipmentsByStrategyPE(uuid: $uuid) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const CREATE_PRODUCTION_EQUIPMENT = gql`
  mutation ProductionEquipment($data: CreateProductionEquipmentInput!) {
    createProductionEquipment(data: $data) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const UPDATE_PRODUCTION_EQUIPMENT = gql`
  mutation ProductionEquipment($data: UpdateProductionEquipmentInput!) {
    updateProductionEquipment(data: $data) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

export const DELETE_PRODUCTION_EQUIPMENT = gql`
  mutation DeleteProductionEquipment($uuid: ID!) {
    deleteProductionEquipment(uuid: $uuid) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;
